import React, { useRef } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import "./SideDrawer.scss";

interface Props {
  isShown: boolean;
}

const SideDrawer: React.FC<Props> = (props) => {
  const nodeRef = useRef(null);
  const content = (
    <CSSTransition
      nodeRef={nodeRef}
      in={props.isShown}
      timeout={300}
      classNames="slideInLeft"
      mountOnEnter
      unmountOnExit
    >
      <aside ref={nodeRef} className="sideDrawer">
        {props.children}
      </aside>
    </CSSTransition>
  );
  return ReactDOM.createPortal(content, document.getElementById("drawer-hook")!);
};

export default SideDrawer;
